import { generateRandomPassword } from "@/utils/functions";
import { intervalToDuration } from "date-fns";
import { UseFormSetValue, UseFormTrigger } from "react-hook-form";
import { IUserForm, IUserRole } from "../../domain/IUser";

export function calculateFullAge(birthDate: Date) {
    const { years } = intervalToDuration({ start: new Date(birthDate), end: new Date()});
    return years;
}

/** Cómo se llama cada rol en pantalla. */
const ETIQUETAS_DE_ROL: Record<string, string> = {
    admin: 'Administrador',
    owner: 'Owner',
    supervisor: 'Supervisor (obsoleto)',
    supervisor_operativo: 'Supervisor operativo',
    supervisor_medico: 'Supervisor médico',
    supervisor_linea: 'Supervisor de línea',
    soporte: 'Soporte',
    doctor: 'Doctor',
    collaborator: 'Enfermero / Colaborador',
}

export function getRoles(roles: IUserRole[] | string = []) {
    if(!Array.isArray(roles) || roles.length === 0) return 'Ningún rol asignado'
    return roles
        .map((role) => ETIQUETAS_DE_ROL[role.role] ?? role.role[0].toUpperCase() + role.role.slice(1))
        .join(', ')
}

export const handleButtonGenPassword = (
    setValue: UseFormSetValue<IUserForm>,
    trigger: UseFormTrigger<IUserForm>
) => {
    const randomPassword = generateRandomPassword()
    setValue('password', randomPassword)
    trigger('password')
}